import { render, staticRenderFns } from "./product.vue?vue&type=template&id=50af1160&scoped=true&"
import script from "./product.vue?vue&type=script&lang=js&"
export * from "./product.vue?vue&type=script&lang=js&"
import style0 from "./product.vue?vue&type=style&index=0&lang=css&"
import style1 from "./product.vue?vue&type=style&index=1&id=50af1160&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50af1160",
  null
  
)

export default component.exports